(function initializeAsNavigation() {
  const desktopBreakpoint = 1025;

  function getNavigationDrawer() {
    return document.querySelector('.as-navigation-drawer');
  }

  function closeNavigationDrawer() {
    const navigationDrawer = getNavigationDrawer();
    const desktopMenuToggle = document.querySelector('.as-desktop-menu-toggle');

    document.body.classList.remove('menu_open');
    desktopMenuToggle?.setAttribute('aria-expanded', 'false');
    navigationDrawer?.querySelector('.as-navigation-secondary')?.classList.remove('is-open');
    navigationDrawer?.querySelectorAll('.as-navigation-primary-action').forEach((primaryAction) => {
      primaryAction.setAttribute('aria-expanded', 'false');
    });
  }

  function activateSecondaryPanel(targetHandle, shouldOpenMobilePanel) {
    const navigationDrawer = getNavigationDrawer();

    if (!navigationDrawer || !targetHandle) {
      return;
    }

    navigationDrawer.querySelectorAll('.as-navigation-primary-action').forEach((primaryAction) => {
      const isActiveAction = primaryAction.dataset.asMenuTarget === targetHandle;

      primaryAction.classList.toggle('is-active', isActiveAction);
      primaryAction.setAttribute('aria-expanded', isActiveAction ? 'true' : 'false');
    });

    navigationDrawer.querySelectorAll('.as-navigation-secondary-panel').forEach((secondaryPanel) => {
      secondaryPanel.classList.toggle('is-active', secondaryPanel.dataset.asMenuPanel === targetHandle);
    });

    if (shouldOpenMobilePanel) {
      navigationDrawer.querySelector('.as-navigation-secondary')?.classList.add('is-open');
    }
  }

  function createDesktopMenuToggle() {
    const desktopMenuToggle = document.querySelector('.as-desktop-menu-toggle');

    if (!desktopMenuToggle || desktopMenuToggle.dataset.asNavigationToggleInitialized === 'true') {
      return;
    }

    desktopMenuToggle.dataset.asNavigationToggleInitialized = 'true';

    desktopMenuToggle.addEventListener('click', () => {
      document.body.classList.add('menu_open');
      desktopMenuToggle.setAttribute('aria-expanded', 'true');

      const firstPrimaryAction = getNavigationDrawer()?.querySelector('.as-navigation-primary-action');
      if (firstPrimaryAction) {
        activateSecondaryPanel(firstPrimaryAction.dataset.asMenuTarget, false);
      }
    });
  }

  function bindNavigationDrawerEvents() {
    const navigationDrawer = getNavigationDrawer();

    if (!navigationDrawer || navigationDrawer.dataset.asNavigationInitialized === 'true') {
      return;
    }

    navigationDrawer.dataset.asNavigationInitialized = 'true';

    navigationDrawer.querySelectorAll('.as-navigation-close').forEach((closeButton) => {
      if (closeButton.classList.contains('as-navigation-mobile-panel-close')) {
        return;
      }

      closeButton.addEventListener('click', closeNavigationDrawer);
    });

    navigationDrawer.querySelector('.as-navigation-mobile-panel-close')?.addEventListener('click', (clickEvent) => {
      clickEvent.preventDefault();
      clickEvent.stopPropagation();

      navigationDrawer.querySelector('.as-navigation-secondary')?.classList.remove('is-open');
      navigationDrawer.querySelectorAll('.as-navigation-primary-action').forEach((primaryAction) => {
        primaryAction.classList.remove('is-active');
        primaryAction.setAttribute('aria-expanded', 'false');
      });
    });

    document.addEventListener('click', (clickEvent) => {
      const clickedOverlay = clickEvent.target.closest('.background-overlay');

      if (clickedOverlay && document.body.classList.contains('menu_open')) {
        clickEvent.preventDefault();
        closeNavigationDrawer();
      }
    });

    navigationDrawer.querySelectorAll('.as-navigation-primary-action').forEach((primaryAction) => {
      primaryAction.addEventListener('mouseenter', () => {
        if (window.innerWidth >= desktopBreakpoint) {
          activateSecondaryPanel(primaryAction.dataset.asMenuTarget, false);
        }
      });

      primaryAction.addEventListener('focus', () => {
        if (window.innerWidth >= desktopBreakpoint) {
          activateSecondaryPanel(primaryAction.dataset.asMenuTarget, false);
        }
      });

      primaryAction.addEventListener('click', () => {
        activateSecondaryPanel(primaryAction.dataset.asMenuTarget, window.innerWidth < desktopBreakpoint);
      });
    });

    document.addEventListener('keydown', (keyboardEvent) => {
      if (keyboardEvent.key === 'Escape' && document.body.classList.contains('menu_open')) {
        closeNavigationDrawer();
      }
    });
  }

  function markHomepageMobileHeader() {
    if (document.body.classList.contains('template-index')) {
      document.querySelector('.header-mobile')?.classList.add('as-home-mobile-header');
    }
  }

  function initializeNavigation() {
    createDesktopMenuToggle();
    bindNavigationDrawerEvents();
    markHomepageMobileHeader();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeNavigation);
  } else {
    initializeNavigation();
  }
})();
